import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

import "./PromoCodeComponent.css";

const PromoCodeAddGroupModal = ({
  addNewGroupModal,
  handleCloseAddGroupModal,
  allUsers,
  setNewAddedEmail,
  newAddedEmail,
  handleAddNewGroup,
  newGroupName,
  setNewGroupName,
}) => {
  return (
    <div>
      <Modal
        show={addNewGroupModal}
        onHide={handleCloseAddGroupModal}
        backdrop="static"
        className="edit-group-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label for="groupName" className="form-label">
              Group Name
            </label>
            <input
              type="text"
              className="form-control"
              id="groupName"
              placeholder="Enter group name"
              value={newGroupName}
              onChange={(e)=> setNewGroupName(e?.target.value)
                }
            />
          </div>
          <div className="col-lg-2 col-sm-12">
            <div className="form-group">
              <label for="userList">Select Users</label>
              <select
                name=""
                id=""
                className="form-control"
                onChange={(e) => {
                  const selectedValue = e?.target?.value;
                  const selectedItem = allUsers?.find(
                    (item) => item?.Id === selectedValue
                  );
                  setNewAddedEmail([...newAddedEmail, selectedItem?.Email]);

                  e.target.value = "";
                }}
              >
                <option value="">Select Email</option>
                {allUsers?.map((item) => {
                  return (
                    <option value={item?.Id}>
                      {item?.Email ? item?.Email : null}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          {newAddedEmail?.length ? (
            <div className="col-lg-12">
              <div className="pro_selected_user">
                <div className="form-group">
                  <label>Selected Users</label>
                  <div className="row">
                    {newAddedEmail?.map((item) => {
                      return (
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                          <div className="selected-user d-flex align-items-center">
                            <input
                              type="text"
                              className="form-control me-2"
                              readonly=""
                              value={item}
                            />
                            <IoMdClose
                              className="cross_butt_email"
                              onClick={() => {
                                const filter = newAddedEmail?.filter(
                                  (i) => i !== item
                                );
                                setNewAddedEmail(filter);
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className="col-lg-2 col-sm-6 col-12">
            <button type="button" className="btn btn-primary common_btn_pd" onClick={handleAddNewGroup}>
              Save Group
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default PromoCodeAddGroupModal;
